// extracted by css-extract-rspack-plugin
export default {"wrap":"Remind__wrap--THH6U","remindButton":"Remind__remindButton--PII_f","modalbody":"Remind__modalbody--mxCuI","icon":"Remind__icon--s2pVj"};